<template>
    <span class="label bg-orange" v-if="unreadNotificationsCountLocal > 0">{{ unreadNotificationsCountLocal }}</span>
</template>

<script>
    export default {
        props: ['unreadNotificationsCount'],
        data: function () {
            return {
                unreadNotificationsCountLocal: null,
            }
        },
        mounted() {
            this.unreadNotificationsCountLocal = this.unreadNotificationsCount;
            EventBus.$on('notificationRead', (unreadNotificationsCount, notificationId, infoMessage) => {
                this.setUnreadNotifications(unreadNotificationsCount);
            })
        },
        methods: {
            setUnreadNotifications(unreadNotificationsCountLocal) {
                this.unreadNotificationsCountLocal = unreadNotificationsCountLocal;
            }
        },
    }
</script>